<app-dialog-heading [heading]="'Create Grandfather'"></app-dialog-heading>
<div class="dialog-content">
  <form [formGroup]="grandfatherFormGroup">

    <mat-form-field>
      <mat-label>Grandfather Name</mat-label>
      <input matInput type="text" [formControl]="nameFormControl" required>
    </mat-form-field>
    <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Grandfather Name')">help_outline</mat-icon>

    <br>

    <div>
      <label class="column-label">Attach the Grandfather to a <b>policy</b> OR <b>insured person</b>:</label>
      <br>
      <mat-radio-group (change)="disableGrandfatherFormField()" [(ngModel)]="chosenGrandfatherApplication"
                       [ngModelOptions]="{standalone: true}" aria-label="Select a policy OR insured person"
                       class="example-radio-group">
        <mat-radio-button *ngFor="let app of grandfatherApplications" [value]="app" class="radio-button">
          {{app}}
        </mat-radio-button>
      </mat-radio-group>
    </div>

    <br>

    <mat-form-field>
      <mat-label>Policy</mat-label>
      <mat-select [formControl]="policyFormControl" required>
        <mat-option *ngFor="let policy of policies" [value]="policy.name">
          {{policy.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Policy')">help_outline</mat-icon>

    <br>

    <mat-form-field>
      <mat-label>Insured Person</mat-label>
      <mat-select [formControl]="insuredPersonFormControl" required>
        <mat-option *ngFor="let person of insuredPersons" [value]="person.name">
          {{person.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Insured Person')">help_outline</mat-icon>

    <br>

    <mat-form-field>
      <mat-label>Select a Formulary</mat-label>
      <input [formControl]="formularyFormControl" matInput type="search" [matAutocomplete]="formularyAuto" (input)="onInputChangedSearchFormularies($event)" (blur)="blurFormulary()">
      <mat-autocomplete #formularyAuto="matAutocomplete">
        <mat-option (onSelectionChange)="formularySelected($event.source.value)" *ngFor="let formulary of filteredFormularies" [value]="formulary.name">
          {{formulary.name}}
        </mat-option>
      </mat-autocomplete>
      <button (click)="clearFormularyName()" *ngIf="formularyFormControl.value" aria-label="Clear"
              mat-button mat-icon-button matSuffix>
        <mat-icon style="color: grey;">clear</mat-icon>
      </button>
    </mat-form-field>
    <mat-icon [matTooltip]="getInfoTooltip('Formulary Name')" class="info-icon">help_outline
    </mat-icon>

  </form>
  <p style="color: red">{{errorMessage}}</p>
</div>
<mat-dialog-actions align="center" class="dialog-button-container">
  <button class="dialog-button" mat-raised-button (click)="onSaveClick()" color="primary">Save</button>
  <button class="dialog-button" mat-raised-button (click)="onCancelClick()" color="warn" >Cancel</button>
</mat-dialog-actions>
